import React from 'react'
import Container from '../Layout/Container'
import Hero from '../Sections/HomeCinematic/Hero'
import Nosotros from '../Sections/HomeCinematic/Nosotros'
import Clientes from '../Sections/HomeCinematic/Clientes'
import Servicios from '../Sections/HomeCinematic/Servicios'
import Contacto from '../Sections/HomeCinematic/Contacto'
import Footer from '../Sections/HomeCinematic/Footer'
import useRefreshScrollTriggers from '../../hooks/useRefreshScrollTriggers'
import useSeo from '../../hooks/useSeo'
import { useTextos } from '../../cms/textos'
import RESPALDO from '../../Data/Paginas/paginaInicio.json'

function Home() {
    useRefreshScrollTriggers()
    useSeo()
    const textos = useTextos('paginaInicio', RESPALDO)

    return (
        <Container>
            <main className="bg-ink">
                <Hero textos={textos.hero} />
                <Nosotros textos={textos.nosotros} />
                <Clientes textos={textos.clientes} />
                <Servicios textos={textos.servicios} />
                <Contacto textos={textos.contacto} />
            </main>
            <Footer />
        </Container>
    )
}

export default Home
